module.exports = "data:text/x-markdown;base64,0KFhbiB5b3UgZ2V0IHRoZSBpdGVtIGZyb20gdGhlIHNob3AgZm9yIGxlc3MgdGhhbiB0aGUgcHJpY2UgYXNrZWQ/CgojIyMjIyBUaGluZ3MgdGhhdCBtaWdodCBoZWxwOgoqIGBTaG9wYCBleHBlY3RzIHRvIGJlIHVzZWQgZnJvbSBhIGBCdXllcmAKKiBVbmRlcnN0YW5kaW5nIGhvdyBgZ2FzKClgIG9wdGlvbnMgd29ya3MK"


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/shop.md
// module id = 1405
// module chunks = 0